import { Draft } from 'immer'
import { v4 } from 'uuid'

import { IScreenDTO, IScreenEntity } from 'src/models/dto/activities/IScreenDTO'
import { ActivityType } from 'src/models/dto/ActivityDTO'
import {
    activity,
    ActivityEntityService,
    factories,
} from 'src/services/EntityServices/ActivityEntityService'

export class IScreenHandler {
    static init() {
        factories.set(ActivityType.LaunchIScreen, () => IScreenHandler.create())
    }

    static get(entityId: string): IScreenEntity {
        return ActivityEntityService.get(entityId) as IScreenEntity
    }

    static create(): IScreenEntity {
        return {
            ...activity(),
            type: ActivityType.LaunchIScreen,
            ppt: ActivityType.LaunchIScreen,
            name: v4(),
            interviewValidityDurationDays: null,
            numberOfCompetencies: null,
            iscreenCompetencies: [],
        }
    }

    private static assign(id: string, obj: Partial<IScreenDTO>) {
        ActivityEntityService.store.assign(id, obj)
    }

    private static produce(id: string, func: (draft: Draft<IScreenEntity>) => void) {
        ActivityEntityService.store.produce(id, func)
    }

    static updateInterviewValidityDurationDays(
        entityId: string,
        interviewValidityDurationDays: number | null
    ) {
        this.assign(entityId, { interviewValidityDurationDays })
    }

    static updateNumberOfCompetencies(entityId: string, numberOfCompetencies: number | null) {
        this.produce(entityId, (entity) => {
            const currentCompetencies = entity.iscreenCompetencies || []

            if (numberOfCompetencies === null) {
                entity.numberOfCompetencies = null
                entity.iscreenCompetencies = []
                return
            }

            entity.numberOfCompetencies = numberOfCompetencies

            // Adjust competency array to match the new count
            if (numberOfCompetencies > currentCompetencies.length) {
                // Add new competencies
                for (let i = currentCompetencies.length; i < numberOfCompetencies; i++) {
                    entity.iscreenCompetencies.push({
                        id: v4(),
                        competencyType: null,
                        iscreenCompetencyTimeLimitSeconds: null,
                    })
                }
            } else if (numberOfCompetencies < currentCompetencies.length) {
                // Remove excess competencies
                entity.iscreenCompetencies.splice(numberOfCompetencies)
            }
        })
    }

    static updateCompetencyType(
        entityId: string,
        competencyId: string,
        competencyType: string | null
    ) {
        this.produce(entityId, (entity) => {
            const index = entity.iscreenCompetencies.findIndex((c) => c.id === competencyId)
            if (index !== -1) {
                entity.iscreenCompetencies[index].competencyType = competencyType
            }
        })
    }

    static updateCompetencyTimeLimit(
        entityId: string,
        competencyId: string,
        iscreenCompetencyTimeLimitSeconds: number | null
    ) {
        this.produce(entityId, (entity) => {
            const index = entity.iscreenCompetencies.findIndex((c) => c.id === competencyId)
            if (index !== -1) {
                entity.iscreenCompetencies[index].iscreenCompetencyTimeLimitSeconds =
                    iscreenCompetencyTimeLimitSeconds
            }
        })
    }
}
